<template>
  <div
    @mouseover="hover = true"
    @mouseleave="hover = false"
    :class="editorClasses"
    group="rowcontent"
  >
    <EditorOptions
      parent="row"
      v-show="hover && ! childHover & ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementContainerClasses">
      <div
        :class="elementClasses"
        :style="elementStyles"
      >
        <draggable
          class="wf-flex wf-w-full wf-flex-row wf-flex-wrap"
          v-model="columns"
          group="columns"
          handle=".column-handle"
        >
          <EditorLayoutColumn
            @mouseover="childHover = true"
            @mouseleave="childHover = false"
            v-for="column in columns"
            :key="column.id"
            :parentModule="parentModule"
          />
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
  import EditorLayoutColumn from  './EditorLayoutColumn'
  import { ConstantsParser } from '../ConstantsParser'
  import EditorElement from '../contracts/EditorElement'
  export default EditorElement.extend({
    props: {
      parentModule: {
        type: String,
        required: true
      }
    },
    components: {EditorLayoutColumn},
    computed: {
      elementContainerClasses() {
        return (new ConstantsParser(this.containerClasses, this.device)).parse()
      },
      menuOptions() {
        return this.$store.getters[`${this.module}/properties`](this.element, this.parentModule).menu
      },
      elementClasses() {
        if (this.previewMode) {
          return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(this.classes, this.device)).parse()]
        }
        let displayClasses = []
        let classes = Object.keys(this.classes).reduce((carry, device) => {
          let deviceDisplayClass = this.classes[device].find(deviceClass => deviceClass.property == 'Display')
          if (deviceDisplayClass) {
            let opacity = 'wf-opacity-100'
            let prefix = ''
            if (device === 'tablet') {
              prefix = 'sm:'
            }
            if (device === 'desktop') {
              prefix = 'lg:'
            }
            if (deviceDisplayClass.value == 'NONE') {
              opacity = 'wf-opacity-50'
            }
            displayClasses.push(`${prefix}${opacity}`)
          }
          let deviceObject = {}
          let deviceClasses = this.classes[device].filter(deviceClass => deviceClass.property != 'Display')
          this.$set(deviceObject, device, deviceClasses)
          return {...carry, ...deviceObject}
        }, {})
        return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(classes, this.device)).parse(), ...displayClasses]
      },
      module() {
        return 'layoutRowModule'
      },
      
      parent() {
        return this.$parent.$parent
      },
      
      family() {
        return 'rows'
      },

      containerClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'containerClasses', this.parentModule)
      },

      classes() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'classes', this.parentModule)
      },
      properties() {
        return this.$store.getters[`${this.module}/properties`](this.element, this.parentModule)
      },
      
      customClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'customClasses', this.parentModule)
      },

      rowIndex() {
        let element = {section: 0}
        return this.$store.getters[`${this.module}/index`](element, this.id, this.parentModule)
      },

      sectionIndex() {
        return this.parent.sectionIndex
      },

      styles() {
        return this.$store.getters[`${this.module}/styles`](this.element, 'styles', this.parentModule)
      },

      columns: {
        get() {
          return this.$store.getters['layoutColumnModule/elements'](this.element, this.parentModule)
        },
        set(value) {
          this.$store.dispatch('layoutColumnModule/updateOrder', {
            section: 0,
            row: this.rowIndex,
            value,
            parentModule: this.parentModule
          })
        },
      },
    },
  })
</script>